import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, timelineItemClasses, TimelineSeparator } from "@mui/lab";
import { Avatar, Box, Button, FormHelperText, FormControlLabel, Checkbox, Grid, IconButton, Paper, Stack, TextField, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { useState } from "react";
import moment from "moment";
import * as React from 'react';
import { dispatch } from 'store';
import { useAddActionTrackerCommentMutation, useGetActionTrackerCommentsQuery } from 'store/slices/apis/actionTrackerSlice';
import { closeSnackbar, openSnackbar } from 'store/slices/snackbar';
import * as Yup from 'yup';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { useCreateProjectActionPendingApprovalMutation } from "store/slices/apis/actionRequestDateChangeSlice";



const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);


export default function AddCommentTracker(props) {
    const { id, data } = props;
    const { projectId } = useParams()
    const [isRequestDate, setIsRequestDate] = useState(false)
    const [requestChangeDate, setrequestChangeDate] = useState("")
    const [createApproval] = useCreateProjectActionPendingApprovalMutation()
    // console.log(data);

    // const [attachments, setAttachments] = React.useState(null);
    const formikRef = React.useRef();
    const [addTrackerCommentFun, addTrackerCommentRes] = useAddActionTrackerCommentMutation();

    // const trackerComments = useGetActionTrackerCommentsQuery({ actionId: data?.projectActionId })
    const [formData, setFormData] = React.useState({
        Comment: '',
        // ProjectActionId: data?.projectActionId,
        CommentType: 'ProjectActionComment',
        // parentCommentId:"",
        IsInternal: true
    });

    const validationSchema = Yup.object({
        // status: Yup.string().required("Status field is required."),
        // Comment: Yup.string().required("Comment field is required.")
    });
    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    // const handleFileChange = (e) => {
    //     setAttachments([...e.target.files]);
    // };

   const handleSubmit = async (values, { setSubmitting, resetForm }) => {
   
     const hasCommentData = values.Comment.trim() !== '' || (values.Attachments && values.Attachments.length > 0);
    
   
    const hasDateData = !!requestChangeDate;

 
    if (hasCommentData) {
        try {
            let modifiyValues = {
                ...values,
                ProjectActionId: data?.projectActionId,
            };

            const fields = new FormData();
            Object.entries(modifiyValues).forEach(([key, value]) => {
                if (key === 'Attachments' && value) {
                    Array.from(value).forEach((file) => {
                        fields.append(`Attachments`, file);
                    });
                } else {
                    fields.append(key, value);
                }
            });

            await addTrackerCommentFun(fields).unwrap();
            openNotification("Comment added successfully", "success");
            resetForm(); 
        } catch (error) {
            openNotification("Failed to add comment", "error");
        }
    }

    
    if (hasDateData) {
        try {
            const reqBody = {
                projectId: projectId,
                projectActionId: data.projectActionId,
                requestChangeDate: requestChangeDate
            };

            await createApproval(reqBody).unwrap();
            openNotification("Request Created successfully", "success");
            setrequestChangeDate(null);
            setIsRequestDate(false);
        } catch (error) {
            openNotification(error?.data?.message || "Approval failed", "error");
        }
    }

    if (!hasCommentData && !hasDateData) {
        openNotification("Please fill at least one field", "info");
    }

    setSubmitting(false);
};


    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsRequestDate(checked);

        if (!checked) {
            setrequestChangeDate("");
        }
    };

    const handleDateChange = (e) => {

        const { name, value } = e.target;

        let utcDate = "";
        if (value) {

            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        setrequestChangeDate(utcDate)

    };



    React.useEffect(() => {
        if (addTrackerCommentRes?.isSuccess) {
            if (addTrackerCommentRes?.data?.status?.toLowerCase() == 'success') {

                formikRef.current?.resetForm();
                openNotification(addTrackerCommentRes?.data?.message, 'success')
                // navigate(`/projects/${projectId}/my-work`);
            } else {
                openNotification(addTrackerCommentRes?.data?.message, 'error')
            }
        }
    }, [addTrackerCommentRes?.isSuccess]);

    React.useEffect(() => {
        if (addTrackerCommentRes?.isError) {
            if (addTrackerCommentRes?.error?.data?.status == 'fail') {
                openNotification(addTrackerCommentRes?.error?.data?.message, 'error')
            } else {
                openNotification(addTrackerCommentRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [addTrackerCommentRes?.isError]);




    return (
        <Formik
            innerRef={formikRef}
            initialValues={formData}
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({
                values, errors, touched, handleChange, handleBlur,
                isSubmitting, setFieldValue, setTouched
            }) => (
                <Form>
                    <Paper sx={{ borderRadius: "3px", boxShadow: 'none' }}>
                        <Stack spacing={1}>
                            <TextField
                                fullWidth
                                name="Comment"
                                value={values?.Comment}
                                onChange={handleChange}
                                onBlur={() => setTouched({ ...touched, Comment: true })}
                                multiline
                                rows={3}
                                placeholder="Write a Comment..."
                                InputProps={{
                                    sx: {
                                        // height: "50px",
                                        // borderRadius: "3px",
                                        backgroundColor: "#fff",

                                        "& input::placeholder": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                            opacity: 1,
                                        },

                                        "& input": {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "100%",
                                            letterSpacing: "0.16px",
                                            color: "#0A0A0C",
                                            fontFamily: "Outfit, sans-serif",
                                        },
                                    },
                                }}
                            />
                            {touched?.Comment && errors?.Comment &&
                                <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.Comment}`}</FormHelperText>
                            }
                            {values?.Attachments &&
                                Array.from(values?.Attachments).map((file, index) => (
                                    <Typography key={index} variant="body2" color="text.secondary">
                                        {file?.name}
                                    </Typography>
                                ))
                            }
                            <Grid size={{ md: 6, xs: 12 }}>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isRequestDate}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="Request to change revised due date"
                                />
                            </Grid>
                            {
                                isRequestDate &&
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <Typography sx={{
                                        fontFamily: 'Outfit',
                                        fontWeight: 500,
                                        fontSize: '16px',
                                        lineHeight: '100%',
                                        letterSpacing: "0px",
                                        mb: 1
                                    }}>Revised Due Date</Typography>
                                    <TextField
                                        type="date"
                                        name="requestChangeDate"
                                        value={requestChangeDate ? new Date(requestChangeDate).toISOString().split('T')[0] : ""}
                                        // onBlur={handleBlur}
                                        onChange={handleDateChange}
                                        onClick={(e) => {
                                            // Trigger the native date picker
                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                            if (input) input.showPicker?.();
                                        }}
                                        fullWidth
                                        sx={{
                                            // ...rightTextStyle,
                                            "& input::-webkit-calendar-picker-indicator": {
                                                display: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& input[type='date']": {
                                                appearance: "none",
                                                WebkitAppearance: "none",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    border: "none",
                                                },
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                >
                                                    {calenderSVG}
                                                </Box>
                                            ),
                                            sx: {
                                                backgroundColor: "#E7E7EB",
                                                height: "40px",
                                                width: { xs: "100%", md: "100%" },
                                                borderRadius: "3px",
                                            },
                                        }}
                                    />
                                </Grid>

                            }

                            <Stack direction="row" spacing={1} alignItems="center">
                                <IconButton component="label">
                                    <AttachFileIcon />
                                    <input
                                        hidden
                                        type="file"
                                        multiple
                                        onChange={(e) => {
                                            console.log(e.target.files);
                                            setFieldValue("Attachments", e.target.files)
                                        }}
                                    />
                                </IconButton>

                                {values?.Attachments?.length > 0 && (
                                    <>
                                        <Typography variant="body2" color="text.secondary">
                                            {values?.Attachments?.length} file(s) selected
                                        </Typography>
                                    </>
                                )
                                }

                                <Box flexGrow={1} />
                                <Button type='submit'
                                    variant="contained"
                                    loading={addTrackerCommentRes?.isLoading}
                                    sx={{
                                        backgroundColor: "#00344C",
                                        borderRadius: "3px",
                                        textTransform: "none",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        lineHeight: "100%",
                                        fontFamily: "Outfit, sans-serif",
                                        color: "#FFFFFF",
                                        px: "20px",
                                        py: "15px",
                                    }}
                                >
                                    Comment
                                </Button>
                            </Stack>
                        </Stack>
                    </Paper>
                    {/* <Grid container spacing={2}>
                        
                        <Grid size={12}>
                            {trackerComments?.data?.data?.length > 0 ?
                                <Timeline
                                    sx={{
                                        [`& .${timelineItemClasses.root}:before`]: {
                                            flex: 0,
                                            padding: 0,
                                        }
                                    }}
                                >
                                    {trackerComments?.data?.data?.map((val, index) => {
                                        return (
                                            <TimelineItem key={index}>
                                                <TimelineSeparator>
                                                    <TimelineConnector />
                                                    <TimelineDot sx={{
                                                        padding: '0px', boxShadow: 'none', margin: "6.5px 0px", borderStyle: 'none', backgroundColor: "inherit"
                                                    }}>
                                                        <Avatar {...stringAvatar(val?.commentBy)} />
                                                    </TimelineDot>
                                                    <TimelineConnector />
                                                </TimelineSeparator>

                                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary">
                                                        {moment(val?.createdDate)?.format('MMMM DD, YYYY')}
                                                    </Typography>
                                                    <Typography variant="h6" component="span"

                                                        sx={{ color: "#1C1C1C", cursor: 'pointer', fontWeight: 400, fontSize: '16px', lineHeight: index === 0 ? "32px" : "24px" }}>
                                                        {val?.commentBy}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '14px' }}>{val?.comment}</Typography>
                                                </TimelineContent>
                                            </TimelineItem>
                                        )
                                    })

                                    }
                                </Timeline>

                                : <Typography variant="caption" sx={{ textAlign: 'center' }}>

                                    Record not found.
                                </Typography>
                            }
                        </Grid>
                    </Grid> */}
                </Form>
            )
            }
        </Formik >
    );
}